<template>
  <div class="container-fluid">
    <br />
    <b-row v-if="creation">
      <b-col class="col-sm-12 col-xl-6">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-edit"></i> {{this.id ? "Atualizar" : "Adicionar"}}
          </div>
          <div class="card-body">
            <form class="form-horizontal" action method="post" enctype="multipart/form-data">
              <div class="form-group row">
                <label class="col-md-3 col-form-label" for="text-input">Solicitante</label>
                <div class="col-md-9">
                  <input
                    class="form-control"
                    id="text-input"
                    type="text"
                    name="text-input"
                    v-model="creation.requester"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-3 col-form-label" for="email-input">Data da Solicitação</label>
                <div class="col-md-9">
                  <b-form-input v-if="!this.id" v-model="date" type="date"></b-form-input>
                  <input
                    v-else
                    class="form-control"
                    id="email-input"
                    type="email"
                    name="email-input"
                    placeholder="dd/mm/yyyy"
                    v-model="creation.creationDate"
                    disabled
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-3 col-form-label" for="password-input">Tipo de Solicitante</label>
                <div class="col-md-9">
                  <b-form-select id="basicSelectLg"
                    v-model="creation.requesterType"
                    size="lg"
                    :plain="true"
                    :options="[{value: 0, text: 'Selecione'},{value: 1, text: 'Nutrição'}, {value: 2, text: 'Educação Física'}, {value: 3, text: 'Psicologia'}]"
                    value="Please select">
                  </b-form-select>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-3 col-form-label" for="password-input">Prioridade</label>
                <div class="col-md-9">
                  <b-form-select id="basicSelectLg"
                    v-model="creation.priority"
                    size="lg"
                    :plain="true"
                    :options="[{value: 0, text: 'Normal'},{value: 1, text: 'Alta'}]"
                    value="Please select">
                  </b-form-select>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-3 col-form-label" for="password-input">Post/Stories</label>
                <div class="col-md-9">
                  <b-form-select id="basicSelectLg"
                    v-model="creation.story"
                    size="lg"
                    :plain="true"
                    :options="[{value: 0, text: 'Post'},{value: 1, text: 'Stories'}]"
                    value="Please select">
                  </b-form-select>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-3 col-form-label" for="textarea-input">Pedido</label>
                <div class="col-md-9">
                  <textarea
                    class="form-control"
                    id="textarea-input"
                    name="textarea-input"
                    rows="1000"
                    v-model="creation.request"
                    style="overflow-y: auto; max-height: 140px !important;"
                  ></textarea>
                </div>
                <div class="col-md-12 text-right">
                  <b-button v-show="!uploadingImage" variant="primary" @click="trigger()">
                    {{!creation.requestImage ? "Adicionar imagem ao pedido" : "Alterar imagem ao pedido" }}
                  </b-button>
                  <Spinner v-show="uploadingImage" />
                  <input
                    @change="onFileInputChanged"
                    ref="fileInput"
                    style="display: none;"
                    type="file"
                    name="file"
                    accept="*"
                  />
                </div>
                <div class="col-md-12 text-right">
                  <p v-if="!creation.requestImage"> Não há anexos deste pedido </p>
                  <a v-else :href="creation.requestImage" target="_blank"> Ver anexo </a>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-3 col-form-label" for="textarea-input">Conteúdo do Post</label>
                <div class="col-md-9">
                  <textarea
                    class="form-control"
                    id="textarea-input"
                    name="textarea-input"
                    rows="1000"
                    v-model="creation.content"
                    style="overflow-y: auto; max-height: 140px !important;"
                  ></textarea>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-3 col-form-label" for="textarea-input">Legenda</label>
                <div class="col-md-9">
                  <textarea
                    class="form-control"
                    id="textarea-input"
                    name="textarea-input"
                    rows="1000"
                    v-model="creation.subtitle"
                    style="overflow-y: auto; max-height: 140px !important;"
                  ></textarea>
                </div>
                <div class="col-md-12 text-right">
                  <p style="float: right;" v-if="creation  && creation.subtitle" v-bind:style="creation.subtitle.length > 2100 ? {color: 'red'} : {}">{{!creation.subtitle ? 0 : creation.subtitle.length}}/2200 {{creation.subtitle.length > 2100 ? " -  Atenção: Verificar no Facebook Studio antes de salvar.": ""}}</p>
                </div>
                <div class="col-md-12 text-right"  v-if="creation  && creation.subtitle && !creation.subtitleApproved">
                  <b-button variant="warning" :disabled="!creation.review" v-on:click="rejectSubtitle()" v-if="!approving">
                    Rejeitar Legenda
                  </b-button>
                  <b-button variant="success" v-on:click="approveSubtitle()" v-if="!approving">
                    Aprovar Legenda
                  </b-button>
                  <Spinner v-else-if="approving" />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-3 col-form-label" for="textarea-input">Instruções</label>
                <div class="col-md-9">
                  <textarea
                    class="form-control"
                    id="textarea-input"
                    name="textarea-input"
                    rows="1000"
                    v-model="creation.instructions"
                    style="overflow-y: auto; max-height: 140px !important;"
                  ></textarea>
                </div>
              </div>
              <b-form-group label="Categorias">
                  <multiselect
                    v-model="selectedCategories"
                    class="background-multiSelect"
                    placeholder="Selecione uma categoria"
                    label="name"
                    track-by="_id"
                    :options="categoriesList"
                    :multiple="true"
                    :taggable="true"
                    :select-label="'Selecionar'"
                    :deselect-label="'Remover'"
                    :selected-label="'Selecionado'"
                    :disabled="creation.sleekerLink"
                    @tag="addTag"
                  ></multiselect>
                  <p v-if="creation.sleekerLink" style="color: red;">Não é possível alterar as categorias porque já há um Sleeker cadastrado para este creation</p>
              </b-form-group>
              <div class="form-group row">
                <b-row>
                  <b-col sm="12">
                    <label for="text-input">Link das Imagens Usadas (Pexels, Freepik, etc.)</label>
                  </b-col>
                  <b-col sm="12">
                    <div v-for="(item, index) in creation.imageLink" :key="index" >
                      <input
                        class="form-control"
                        id="text-input"
                        type="text"
                        name="text-input"
                        v-model="item.link"
                      />
                    </div>
                  </b-col>
                  <b-col sm="12">
                    <b-button variant="primary" v-on:click="creation.imageLink.push({link: ''})">
                      <i class="fa fa-edit"></i> Adicionar Fonte da Imagem
                    </b-button>
                  </b-col>
                </b-row>
              </div>
              <div class="form-group row">
                <b-row>
                  <b-col sm="12">
                    <label for="text-input">Link das Artes</label>
                  </b-col>
                  <b-col sm="12">
                    <div v-for="(item, index) in creation.artLink" :key="index" >
                      <input
                        class="form-control"
                        id="text-input"
                        type="text"
                        name="text-input"
                        v-model="item.link"
                      />
                    </div>
                  </b-col>
                  <b-col sm="12">
                    <b-button variant="primary" v-on:click="creation.artLink.push({link: ''})">
                      <i class="fa fa-edit"></i> Adicionar Arte
                    </b-button>
                  </b-col>
                  <b-col sm="12">
                    <p style="color: red; float: right;" v-if="invalidArtLink" class="">Precisa ser o link de um arquivo válido no drive</p>
                  </b-col>
                </b-row>
              </div>
              <div class="form-group row">
                <label class="col-md-3 col-form-label" for="text-input">Link do Sleeker</label>
                <div class="col-md-9">
                  <input
                    class="form-control"
                    id="text-input"
                    type="text"
                    name="text-input"
                    v-model="creation.sleekerLink"
                  />
                </div>
              </div>
              <div class="text-center">
                <b-button variant="primary" v-show="!creation || !creation.sleekerLink" v-on:click="createSleeker()">
                  <i class="fa fa-edit"></i> Criar Sleeker
                </b-button>
                <b-button variant="primary" :disabled="uploading" v-show="!creation || !creation.sleekerLink" v-on:click="createSleekerPSD()">
                  <i class="fa fa-edit"></i> Criar com PSD
                </b-button>
                <Spinner v-if="uploading" />
                <input
                  @change="onFileInputPSDChanged"
                  ref="fileInputPSD"
                  style="display: none;"
                  type="file"
                  name="file"
                  accept="*"
                />
              </div>
              <br/>
              <div class="form-group row">
                <label class="col-md-3 col-form-label" for="textarea-input">Revisão</label>
                <div class="col-md-9">
                  <textarea
                    class="form-control"
                    id="textarea-input"
                    name="textarea-input"
                    rows="1000"
                    v-model="creation.review"
                    style="overflow-y: auto; max-height: 140px !important;"
                  ></textarea>
                </div>
              </div>
            </form>
          </div>
          <div v-show="!creation || !creation.controller" class="card-footer text-center">
            <div class="form-group row">
              <label class="col-md-3 col-form-label" for="textarea-input">Responsável</label>
              <div class="col-md-9">
                <b-form-select id="basicSelectLg"
                  v-model="newController"
                  size="lg"
                  :plain="true"
                  :options="adminOptions"
                  value="Escolha">
                </b-form-select>
              </div>
            </div>
            <b-button variant="primary" :disabled="controlling" v-on:click="getControl()">
              <i class="fa fa-check"></i> Definir Controle
            </b-button>
            <Spinner v-if="controlling" />
          </div>
          <div class="card-footer text-center" v-show="creation && creation.controller">
            <div class="form-group row">
              <label class="col-md-3 col-form-label" for="textarea-input">Responsável</label>
              <div class="col-md-9">
                <input
                  disabled
                  class="form-control"
                  id="text-input"
                  type="text"
                  name="text-input"
                  v-model="creation.controller"
                />
              </div>
            </div>
            <b-button variant="warning" :disabled="controlling" v-on:click="releaseControl()">
              <i class="fa fa-ban"></i> Liberar Controle
            </b-button>
            <Spinner v-if="controlling" />
          </div>
          <div class="card-footer text-center">
            <b-button variant="primary" :disabled="!canSave || saving || (this.id && !this.creation.controller)" v-on:click="saveCreation(true)">
              <i class="fa fa-save"></i> Salvar
            </b-button>
            <Spinner v-if="saving" />
          </div>
          <div class="card-footer text-center">
            <b-button variant="default" :disabled="!canSave || saving || (this.id && !this.creation.controller)" v-on:click="saveCreation()">
              <i class="fa fa-save"></i> Salvar e Adicionar mais um
            </b-button>
            <Spinner v-if="saving" />
          </div>
          <div class="card-footer text-center">
            <b-button variant="success" v-on:click="finish()">
              <i class="fa fa-save"></i> Arquivar 
            </b-button>
          </div>
          <div class="card-footer text-center">
            <b-button variant="warning" v-on:click="goToList()">
              <i class="fa fa-save"></i> Ir para listagem
            </b-button>
          </div>
          <div class="card-footer text-center">
            <b-button variant="danger" v-if="this.id" v-on:click="deleteCreation()">
              <i class="fa fa-trash"></i> Apagar
            </b-button>
          </div>
        </div>
      </b-col>
      <b-col class="col-sm-12 col-xl-6">
        <b-row>
          <b-col class="col-sm-12">
            <div class="card">
              <div class="card-header">
                <i class="fa fa-user"></i> Ações
              </div>
              <div class="card-body">
                <ul class="list-group" v-if="creationActions">
                  <li v-for="(item, index) in creationActions" v-bind:key="index" class="list-group-item">{{item.insertionDate| moment("DD/MM/YYYY HH:mm")}}: <b>{{adminsMap[item.userId]}}</b> {{getActionDescriptionByType(item.type)}} <i>{{item.creationDescription ? item.creationDescription : ''}}</i> - <a v-if="item.type != 2" target="_blank" v-bind:href="'/admin/creation/update/' + item.creationId"> Ver Creation</a><a v-else target="_blank" v-bind:href="item.details"> Ver Sleeker</a></li>
                </ul>  
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <br />
  </div>
</template>

<script>
import service from "../service";
import Spinner from "./Spinner";
import Multiselect from "vue-multiselect";
import Config from "../config";

export default {
  name: "CreationItem",
  props:  {
    id: undefined
  },
  data: () => {
    return {
      creation: {
        artLink: [],
        imageLink: []
      },
      selectedCategories: [],
      date: undefined,
      categoriesListPosts: [],
      categoriesListStories: [],
      controlling: false,
      admins: [],
      newController: "",
      creationActions: [],
      adminsMap: {},
      uploading: false,
      saving: false,
      approving: false,
      uploadingImage: false
    };
  },
  computed: {
    categoriesList: function() {
      if (this.creation) {
        if (this.creation.story) {
          return this.categoriesListStories;
        } else {
          return this.categoriesListPosts;
        }
      } else {
        return [];
      } 
    },
    canSave: function () {
      if (this.invalidArtLink) {
        return false;
      }

      return true;
    },
    adminOptions: function ()  {
      if (!this.admins) {
        return [];
      } else {
        let result = [];
        for (let key in this.admins) {
          result.push({value: this.admins[key].id, text: this.admins[key].email});
        }
        return result;
      }
    },
    invalidArtLink: function () {
      if (this.creation.artLink && this.creation.artLink.length) {
        for (let key in this.creation.artLink) {
          console.log("link");
          let link = this.creation.artLink[key].link;
          console.log(link);
          if (!link || link.indexOf("drive") < 0 || link.indexOf("folder") >= 0) {
            return true;
          }
        }
      }
      
      return false;
    }
  },
  methods: {
    trigger() {
      this.$refs.fileInput.click();
    },
    finish: function () {
      this.creation.finished = true;
      this.saveCreation();
    },
    onFileInputChanged(event) {
      console.log("onFileInputChanged");
      this.uploadingImage = true;
      this.uploadFiles(event.target.files);
    },
    uploadFiles(files) {
      this.loading = true;
      
      var formData = new FormData();
      formData.append("file", files[0]);
      
      const baseURL = Config.BASE_API_URL;

      let vm = this;

      fetch(baseURL + "upload-file-creation", {
        headers: {
          "Conectados-Auth": localStorage.sessionId
        },
        method: "POST",
        body: formData,
        bypassInterceptor: true
      }).then((response) => {
        if (response && response.status && response.status === 200) {
          response.json().then((json) => {
            if (json &&  json.url) {
              vm.creation.requestImage = json.url;
            } else {
              alert("Erro no upload");
            }
            vm.uploadingImage = false;
          });
        } else {
          alert("Erro no upload");
          vm.uploadingImage = false;
        }
      });
    },
    rejectSubtitle: function () {
      this.approving = true;
      this.saveCreation();
    },
    approveSubtitle: function () {
      this.approving = true;
      this.creation.subtitleApproved = true;
      this.saveCreation();
    },
    releaseControl: function() {
      this.controlling = true;
      service.releaseCreationControl(this.creation._id).then(() => {
        this.controlling = false;
        this.creation.controller = undefined;
      });
    },
    getActionDescriptionByType: function(type) {
      let description = "";

      switch(type) {
        case 0:
          description = "definiu o conteúdo neste item: "
        break;
        case 1:
          description = "criou uma legenda neste item: "
        break;
        case 2:
          description = "cadastrou um Sleeker "
        break;
        case 3:
          description = "cadastrou um PSD neste item: "
        break;
        case 4:
          description = "alterou a legenda deste item: "
        break;
        case 5:
          description = "aprovou a legenda deste item: "
        break;
      }

      return description;
    },
    getControl: function() {
      this.controlling = true;
      service.getCreationControl(this.creation._id, this.newController).then(() => {
        this.controlling = false;

        for (let key in this.admins) {
          if (this.admins[key].id == this.newController) {
            this.creation.controller = this.admins[key].name;
            break;
          }
        }

        if (!this.creation.controller) {
          this.creation.controller = this.newController;
        }
      });
    },
    addTag: function(newTag) {
      const tag = {
        name: newTag
      };
      this.categoriesList.push(tag);
      this.selectedCategories.push(tag);
    },
    saveCreation: function(goToCreated) {
      this.saving = true;
      this.creation.categories = this.selectedCategories;
      if (this.id) {
        service.updateCreation(this.creation).then(() => {
            this.saving = false;
            this.loadCreation();  
          }
        ).catch(() => {
          alert("error");
        });
      } else {
        if (this.date) {
          this.creation.preformatedDate = this.date;
        }

        if (!this.creation.categories || !this.creation.categories.length) {
          alert("É obrigarório cadastrar categorias. Podem ser alteradas depois.")
          this.saving = false;
        } else {
          service.addCreation(this.creation).then((result) => {
            this.saving = false;
            this.approving = false;

            if (goToCreated) {
              this.$router.push("/admin/creation/update/" + result.id);
            }
          }).catch(() => {
            alert("error");
          });
        }
      }
    },
    loadCreation: function() {
      if (this.id) {
        service.getCreation(this.id).then((result) => {
            if (result && result.creation) {
              this.creation = result.creation;

              if (result.creationActions) {
                this.creationActions = result.creationActions;
              }
              
              this.date = new Date(this.creation.creationDate);
              if (this.creation.categories  && this.creation.categories.length) {
                this.selectedCategories = this.creation.categories;
              }
            }
        }).catch(() => {
          alert("error");
        });
      }
    },
    deleteCreation: function() {
      service.deleteCreation(this.creation._id).then(() => {
          alert("ok");
        }
      ).catch(() => {
        alert("error");
      });
    },
    goToList: function() {
      this.$router.push("/admin/creation/list");
    },
    createSleeker: function() {
      this.$router.push({ name: 'Editor', params: {id: "new", creation: this.creation._id, isStory: this.creation.story}});
    },
    createSleekerPSD: function() {
      this.$refs.fileInputPSD.click();
    },
    onFileInputPSDChanged(event) {
      this.uploadFilesPSD(event.target.files);
    },
    uploadFilesPSD(files) {
      this.uploading = true;
      
      var formData = new FormData();
      formData.append("file", files[0]);
      
      const baseURL = Config.BASE_API_URL;

      var vm = this;
      fetch(baseURL + "upload-psd", {
        headers: {
          "Conectados-Auth": localStorage.sessionId
        },
        method: "POST",
        body: formData,
        bypassInterceptor: true
      }).then((response) => {
        if (response && response.status && response.status === 200) {
          response.json().then(jsonResponse => {
            vm.loading = false;
            this.$router.push({ name: 'Editor', params: {id: "new", creation: this.creation._id, json: JSON.parse(jsonResponse.json)}});
          });
        } else {
          vm.loading = false;
          alert("Erro ao subir este PSD.");
        }
      });
    }
  },
  components: { Spinner, Multiselect},
  created() {
    service.getAllCategories().then(
      response => {
        this.categoriesListPosts = response;
      },
      () => {
        this.showError = true;
      }
    );

    service.getAllStoryCategories().then(
      response => {
        this.categoriesListStories = response;
      },
      () => {
        this.showError = true;
      }
    );

    service.getAdmins().then(
      response => {
        this.admins = response.admins;
        this.adminsMap = {};
        for (let key in this.admins) {
          let admin = this.admins[key];
          this.adminsMap[admin.id] = admin.name;
        }
      },
      () => {
        this.showError = true;
      }
    );
    
    this.loadCreation();
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



<style lang="css" scoped>
.background-multiSelect >>> .multiselect__tag {
  background: #20a8d8 !important;
}
</style>


<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>


